import to from "await-to-js";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DatePicker } from "../../../../../../components/DatePicker/DatePicker";
import { Input } from "../../../../../../components/Input/Input";
import { Table } from "../../../../../../components/Table/Table";
import { ModalsContext } from "../../../../../../context/modals.context";
import { DATE_FORMAT } from "../../../../../../core/constants";
import { ExciseStampsContext } from "../../../../../../modules/obligee/exciseStamps/exciseStamps.context";
import { exciseStampsService } from "../../../../../../modules/obligee/exciseStamps/exciseStamps.service";
import style from "./Retail.module.scss";

interface IINITIAL_PARAMSProps {
  marka: string | null;
  datumVazenjaOd: any;
  datumVazenjaDo: any;
}

const INITIAL_PARAMS = () => ({
  marka: null,
  datumVazenjaOd: null,
  datumVazenjaDo: null,
});

export const Retail = () => {
  const { exciseStamps, setExciseStamps } = useContext(ExciseStampsContext);
  const { setError } = useContext(ModalsContext);
  const [totalData, setTotalData] = useState(1);
  const [params, setParams] = useState<IINITIAL_PARAMSProps>(INITIAL_PARAMS());
  const { t } = useTranslation();

  const colDef = [
    { title: t("TABLES.NAZIV_MARKE"), dataIndex: "nazivMarke" },
    { title: t("TABLES.MALOPRODAJNA_CENA"), dataIndex: "maloprodajnaCena" },
    {
      title: t("TABLES.BROJ_SLUZBENOG_GLASNIKA"),
      dataIndex: "brojSluzbenogGlasnika",
    },
    { title: t("TABLES.DATUM_OBJAVE"), dataIndex: "datumObjave" },
    {
      title: t("TABLES.DATUM_OD_KADA_VAZI_CENA"),
      dataIndex: "datumOdKadaVaziCena",
    },
  ];

  const postMaloprodajneCeneMarkiProizvoda = async (
    page: number | null,
    pageSize: number | null
  ) => {
    const [err, res] = await to(
      exciseStampsService.postMaloprodajneCeneMarkiProizvoda({
        markicaKategorijeId: exciseStamps.kategorijaProizvodaId,
        filter: {
          marka: params.marka,
          datumVazenjaOd: params.datumVazenjaOd,
          datumVazenjaDo: params.datumVazenjaDo,
          pageNumber: page,
          pageSize: pageSize,
        },
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    setTotalData(res.data.totalCount);
    setExciseStamps({
      maloprodajneCeneMarkiProizvoda: res.data.result,
    });
  };

  useEffect(() => {
    postMaloprodajneCeneMarkiProizvoda(1, 20);
  }, [params]);

  return (
    <div>
      <div className={style.buttonContainer} id="retail">
        <Input
          placeholder={t("PLACEHOLDERS.MARKA")}
          className="w-32"
          allowClear
          onChange={({ target }) =>
            setParams({ ...params, marka: target.value })
          }
          name="naziv-marke"
        />
        <DatePicker
          placeholder={t("PLACEHOLDERS.DATUM_VAZENJA_OD")}
          allowClear
          className="w-32"
          format={DATE_FORMAT}
          onChange={(value) => setParams({ ...params, datumVazenjaOd: value })}
          name="datum-vazenja-od-maloprodajne-cene"
        />
        <DatePicker
          placeholder={t("PLACEHOLDERS.DATUM_VAZENJA_DO")}
          allowClear
          className="w-32"
          format={DATE_FORMAT}
          onChange={(value) => setParams({ ...params, datumVazenjaDo: value })}
          name="datum-vazenja-do-maloprodajne-cene"
        />
      </div>
      <Table
        columns={colDef}
        scrollConfig={[".ant-tabs-nav", "#retail"]}
        pagination={{
          total: totalData,
          onChange: (page, pageSize) => {
            postMaloprodajneCeneMarkiProizvoda(page, pageSize);
          },
        }}
        dataSource={exciseStamps.maloprodajneCeneMarkiProizvoda}
        name="maloprodajna-cena-tabela"
      />
    </div>
  );
};
